// extracted by mini-css-extract-plugin
export default {"body":"styles_body__IUNRq","content":"styles_content__hWGY8","actions":"styles_actions__THB4Q"};